/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import DatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import {
	getAllergies,
	getContacts,
	getEnrolledStudents,
	getImmunizationsReport,
	getMealReport,
	getMedications,
	getRoomRatios,
	getRooms,
	// getParentsSubscription,
	getSchoolRoyalties,
	getStaffs,
	getStudentsAge,
} from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import {
	CircularProgress,
	FormControl,
	FormHelperText,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Reports.css';
import { useNavigate } from 'react-router-dom';


const listOfReports = [
	{ key: 'ratio', label: 'Ratio' },
	{ key: 'staff', label: 'Staff' },
	{ key: 'enrolled-student', label: 'Enrolled Student' },
	{ key: 'age', label: 'Age' },
	{ key: 'allergy', label: 'Allergy' },
	{ key: 'contact', label: 'Contact' },
	{ key: 'immunization', label: 'Immunization Record' },
	{ key: 'immunization-due-overdue', label: 'Immunization Due/Overdue' },
	{ key: 'medication', label: 'Medication' },
	{ key: 'meal', label: 'Meal' },
	// { key: 'subscription', label: 'Subscription Reporting' },
	{ key: 'royalties', label: 'Royalties Reporting' },
];

const DownloadReports = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const user = useSelector(({ auth }) => auth.user);
	const [filters, setFilters] = useState({
		school_id: user?.school?.id || user?.data?.school?.id,
		export_id: 0,
		status: '',
		student_id: '',
		fromDate: '',
		toDate: '',
		room_id: '',
		interval: '',
		package_type: '',
		role: '',
	});
	const [roomPage, setRoomPage] = useState(1);
	const [rooms, setRooms] = useState([]);
	const [iisLoading, ssetIsLoading] = useState(false);
	const [errorFields, setErrorsFields] = useState({});

	useEffect(() => {
		let isMounted = true;
		getRooms('', roomPage)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});
		return () => {
			isMounted = false;
		};
	}, [roomPage, dispatch]);

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		setFilters({ ...filters, [name]: value });
		setErrorsFields({ ...errorFields, [name]: '' });
		if (name === 'report_type' && value === 'staff') {
			setFilters({ ...filters, [name]: value, room_id: '' });
		}
	};

	const sendEmail = () => {
		let errors = 0;
		let e = {};
		if (!filters.report_type) {
			errors = 1;
			e = { ...e, report_type: 'This fields is required' };
		} else {
			e = { ...e, report_type: '' };
		}
		if (!filters.room_id && filters.report_type !== 'staff') {
			errors = 1;
			e = { ...e, room_id: 'This fields is required' };
		} else {
			e = { ...e, room_id: '' };
		}

		if (!filters.fromDate && filters.report_type !== 'ratio') {
			errors = 1;
			e = { ...e, date_from: 'This fields is required' };
		} else {
			e = { ...e, date_from: '' };
		}

		if (!filters.toDate && filters.report_type !== 'ratio') {
			errors = 1;
			e = { ...e, date_to: 'This fields is required' };
		} else {
			e = { ...e, date_to: '' };
		}
		// split email field by comma and space
		const emails = filters.email?.split(/,| /);
		// if more than 1 email is entered, consider it invalid
		const re = /\S+@\S+\.\S+/;
		if (!filters.email) {
			errors = 1;
			e = { ...e, email: 'This fields is required' };
		} else if (emails.length > 1 || !re.test(filters.email)) {
			errors = 1;
			e = { ...e, email: 'Invalid email' };
		} else {
			e = { ...e, email: '' };
		}
		if (filters.report_type === 'ratio') {
			if (!filters.interval) {
				errors = 1;
				e = { ...e, interval: 'This fields is required' };
			} else {
				e = { ...e, interval: '' };
			}
			if (!filters.date) {
				errors = 1;
				e = { ...e, date: 'This fields is required' };
			} else {
				e = { ...e, date: '' };
			}
		}
		setErrorsFields(e);
		if (errors) {
			return;
		}
		ssetIsLoading(true);
		let changingFilters = false;
		if (filters.room_id === 'all') {
			filters.room_id = '';
			changingFilters = true;
		}
		switch (filters.report_type) {
			// add catch in all cases
			case 'ratio': {
				const room = rooms.find((r) => r.id === filters.room_id);
				getRoomRatios(1, filters.room_id, filters.date, filters.interval, room.name, 1, filters.email)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			}
			case 'staff':
				getStaffs(filters, 1, '', 1, 1, filters.email)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'enrolled-student':
				getEnrolledStudents(
					1,
					'',
					filters.school_id,
					filters.room_id,
					'',
					filters.fromDate,
					filters.toDate,
					1,
					1,
					filters.email,
				)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'age':
				getStudentsAge(
					1,
					'',
					filters.school_id,
					filters.room_id,
					'',
					filters.fromDate,
					filters.toDate,
					1,
					1,
					filters.email,
				)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'allergy':
				getAllergies(filters, 1, '', 1, 1, filters.email)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'contact':
				getContacts(filters, 1, '', 1, 1, filters.email)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'immunization':
				getImmunizationsReport(
					1,
					'',
					filters.school_id,
					filters.room_id,
					'',
					filters.fromDate,
					filters.toDate,
					1,
					0,
					1,
					filters.email,
				)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'immunization-due-overdue':
				getImmunizationsReport(
					1,
					'',
					filters.school_id,
					filters.room_id,
					'',
					filters.fromDate,
					filters.toDate,
					1,
					1,
					1,
					filters.email,
				)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'medication':
				getMedications(filters, 1, '', 1, 1, filters.email)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			case 'meal': {
				const allRooms = rooms.map((room) => room.id);
				getMealReport(filters, 1, allRooms, 1, filters.email)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,

								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			}
			// case 'subscription':
			// 	getParentsSubscription(
			// 		1,
			// 		'',
			// 		filters.school_id,
			// 		filters.room_id,
			// 		'',
			// 		filters.fromDate,
			// 		filters.toDate,
			// 		1,
			// 		1,
			// 		filters.email
			// 	)
			// 		.then((res) => {
			// 			dispatch(
			// 				Actions.showMessage({
			// 					message: 'Email sent successfully.',
			// 					autoHideDuration: 1500,
			// 					variant: 'success',
			// 				})
			// 			);
			// 			ssetIsLoading(false);
			// 		})
			// 		.catch((err) => {
			// 			dispatch(
			// 				Actions.showMessage({
			// 					message: 'Failed to send email.',
			// 					autoHideDuration: 1500,
			// 					variant: 'error',
			// 				})
			// 			);
			// 			ssetIsLoading(false);
			// 		});
			// 	break;
			case 'royalties':
				getSchoolRoyalties(filters, '', 1, 1, 1, 1, filters.email)
					.then((res) => {
						dispatch(
							Actions.showMessage({
								message: 'Email sent successfully.',
								autoHideDuration: 1500,
								variant: 'success',
							}),
						);
						ssetIsLoading(false);
					})
					.catch((err) => {
						dispatch(
							Actions.showMessage({
								message: 'Failed to send email.',
								autoHideDuration: 1500,
								variant: 'error',
							}),
						);
						ssetIsLoading(false);
					});
				break;
			default:
				dispatch(
					Actions.showMessage({
						message: 'Select report type.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
				ssetIsLoading(false);
		}
		if (changingFilters) {
			filters.room_id = 'all';
		}
	};
	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="flex flex-col items-center">
				<div className="flex items-center flex-nowrap self-start pl-40">
					<div className="reports-topDiv">
						<h1 className="my-16">
							{' '}
							<span className="">
								<IconButton
									onClick={() => {
										navigate(-1);
									}}
								>
									<img alt="filter" className="" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>{' '}
							<span className="text-pd-xl self-end font-bold mr-28"> Downloads</span>
						</h1>
						<p>Export a variety of reports such as Activity, Staff, and Immunization.</p>
					</div>
				</div>
				<div className="p-64 py-32 bg-white rounded flex flex-col gap-16" style={{ width: '75vw', minHeight: '60vh' }}>
					<div className="flex items-center">
						<h2 className="font-bold">Available Reports</h2>
					</div>
					<div className="flex justify-between gap-80">
						{filters.report_type === 'ratio' ? (
							<>
								<div className="flex-grow">
									<DatePicker
										errTxts={errorFields.date}
										id="date"
										label="Date"
										maxDate={new Date()}
										name="date"
										setValue={(Date) => {
											setErrorsFields({ ...errorFields, date: false });
											setFilters({ ...filters, date: Date?.format('YYYY-MM-DD') || '' });
										}}
										value={filters.date}
									/>
								</div>
								<FormControl className="flex-grow" error={!!errorFields.interval} style={{ width: '23%' }}>
									<InputLabel id="interval">Interval</InputLabel>
									<Select
										className="interval-select"
										endAdornment={
											filters.interval ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																interval: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="interval"
										label="Time Interval"
										labelId="interval"
										name="interval"
										onChange={handleFilters}
										value={filters.interval}
									>
										<MenuItem value="fifteen">15 Minute</MenuItem>
										<MenuItem value="thirty">30 Minute</MenuItem>
										<MenuItem value="sixty">1 Hour</MenuItem>
									</Select>
									{errorFields.interval ? <FormHelperText>{errorFields.interval}</FormHelperText> : null}
								</FormControl>
							</>
						) : (
							<>
								<div className="flex-grow">
									<DatePicker
										errTxts={errorFields.date_from}
										id="date-from"
										label="Date From"
										maxDate={filters.toDate || new Date()}
										name="date_from"
										setValue={(Date) => {
											setErrorsFields({ ...errorFields, date_from: false });
											setFilters({ ...filters, fromDate: Date?.format('YYYY-MM-DD') || '' });
										}}
										value={filters.fromDate}
									/>
								</div>
								<div className="flex-grow">
									<DatePicker
										errTxts={errorFields.date_to}
										id="date-to"
										label="Date To"
										maxDate={new Date()}
										minDate={filters.fromDate}
										name="date_to"
										setValue={(Date) => {
											setErrorsFields({ ...errorFields, date_to: false });
											setFilters({ ...filters, toDate: Date?.format('YYYY-MM-DD') || '' });
										}}
										value={filters.toDate}
									/>
								</div>
							</>
						)}
					</div>
					<div className="flex justify-between gap-80">
						<div className="w-full">
							<FormControl className="w-full" error={!!errorFields.report_type}>
								<InputLabel id="report_type_label">Report Type</InputLabel>
								<Select
									className="w-full"
									id="report_type"
									label="Report Type"
									labelId="report_type_label"
									name="report_type"
									onChange={handleFilters}
									value={filters.report_type}
								>
									{listOfReports.map((report) => {
										return (
											<MenuItem id={report.key} key={report.key} value={report.key}>
												{report.label}
											</MenuItem>
										);
									})}
								</Select>
								{errorFields.report_type ? <FormHelperText>{errorFields.report_type}</FormHelperText> : null}
							</FormControl>
						</div>
						<div className="w-full">
							<FormControl className="w-full" disabled={filters.report_type === 'staff'} error={errorFields.room_id}>
								<InputLabel id="roomLabel">Room</InputLabel>
								<Select
									className="w-full"
									disabled={filters.report_type === 'staff'}
									endAdornment={
										filters.room_id ? (
											<IconButton className="mr-16" id="clear-room-filter" size="small">
												<Close
													fontSize="small"
													onClick={() => {
														setFilters({
															...filters,
															room_id: '',
														});
													}}
												/>
											</IconButton>
										) : (
											''
										)
									}
									id="room_id"
									label="Room"
									labelId="roomLabel"
									name="room_id"
									onChange={handleFilters}
									value={filters.room_id}
								>
									{rooms.length ? <MenuItem value="all">All</MenuItem> : null}
									{rooms.length ? (
										rooms.map((room) => {
											return (
												<MenuItem id={room.id} key={room.id} value={room.id}>
													{room.name}
												</MenuItem>
											);
										})
									) : (
										<MenuItem disabled>Loading...</MenuItem>
									)}
								</Select>
								{errorFields.room_id ? <FormHelperText>{errorFields.room_id}</FormHelperText> : null}
							</FormControl>
						</div>
					</div>

					<div className="mt-16">
						<TextField
							className="w-full"
							error={!!errorFields.email}
							helperText={errorFields.email}
							label="Email Address"
							name="email"
							onChange={handleFilters}
							value={filters.email}
						/>
					</div>
					<div className="self-center mt-32">
						{!iisLoading ? (
							<div className="flex justify-center" style={{ gap: 20 }}>
								<CustomButton
									fontSize="15px"
									onClick={() => {
										navigate(-1);
									}}
									variant="secondary"
									width="135px"
								>
									Cancel
								</CustomButton>

								<CustomButton onClick={sendEmail} width={140}>
									{' '}
									Submit
								</CustomButton>
							</div>
						) : (
							<div className="circle-bar">
								<CircularProgress size={35} />
							</div>
						)}
					</div>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default DownloadReports;
